import moment from 'moment';

export const squadComparator = (a,b) => {
  if (!b.eventNumberOfBowlers || a.eventNumberOfBowlers > b.eventNumberOfBowlers) {
    return -1;
  }
  if (!a.eventNumberOfBowlers || b.eventNumberOfBowlers > a.eventNumberOfBowlers) {
    return 1;
  }
  if (!b.startDateTime && a.startDateTime) {
    return -1;
  }
  if (b.startDateTime && !a.startDateTime) {
    return 1;
  }
  if (!b.startDateTime || moment.parseZone(a.startDateTime).isBefore(moment.parseZone(b.startDateTime))) {
    return -1;
  }
  if (!a.startDateTime || moment.parseZone(a.startDateTime).isAfter(moment.parseZone(b.startDateTime))) {
    return 1;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/features/shared/util/squadComparator.js